<button class="close modalClose" mat-button (click)="onNoClick()" tabindex="-1">
  X
</button>
<h1 mat-dialog-title>{{ message }}</h1>
<div mat-dialog-content>
  <p>{{ submessage }}</p>
</div>
<div mat-dialog-actions align="end">
  <button
    mat-button
    mat-dialog-close
    class="button_small"
    (click)="onConfirmClick()"
    tabindex="-1"
  >
    view site
  </button>
</div>
